const mediaItems = [
  {
    title: '红桃视频 · 品质剧场巡礼',
    desc: '独家探访红桃视频优质内容制作幕后，发现品质好剧的诞生过程',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20atmosphere%20with%20warm%20coral%20and%20dark%20tones%2C%20film%20production%20abstract%20composition%2C%20soft%20dramatic%20lighting%2C%20no%20faces%2C%20professional%20film%20set%20aesthetic&width=800&height=450&seq=media-01-bale&orientation=landscape',
    duration: '3:25',
    tag: '红桃视频',
    tagColor: 'bg-primary-500',
  },
  {
    title: '樱花视频 · 樱花季特别企划',
    desc: '樱花视频年度重磅企划，集合全年最受好评的独家内容回顾',
    img: 'https://readdy.ai/api/search-image?query=Soft%20pink%20cherry%20blossom%20spring%20cinematic%20atmosphere%2C%20gentle%20petal%20bokeh%2C%20warm%20golden%20hour%20lighting%2C%20film%20aesthetic%2C%20no%20faces%2C%20dreamy%20composition&width=800&height=450&seq=media-02-bale&orientation=landscape',
    duration: '5:12',
    tag: '樱花视频',
    tagColor: 'bg-accent-500',
  },
  {
    title: '糖豆视频 · 快乐源泉大揭秘',
    desc: '揭秘糖豆视频短剧频道的爆款密码，看轻松内容如何俘获观众',
    img: 'https://readdy.ai/api/search-image?query=Bright%20playful%20entertainment%20atmosphere%20with%20warm%20golden%20and%20dark%20tones%2C%20abstract%20fun%20composition%2C%20colorful%20bokeh%20lights%2C%20energetic%20mood%2C%20no%20faces&width=800&height=450&seq=media-03-bale&orientation=landscape',
    duration: '4:08',
    tag: '糖豆视频',
    tagColor: 'bg-secondary-500',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">精彩视频</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">各平台精选内容推荐与专题介绍</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all shadow-lg">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded-full text-white text-xs font-medium ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-black/60 text-white text-xs font-mono backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}